import React, { Fragment } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function EnquiriesTableSkelton({ cols = 6 }) {
  const count = Math.max(1, Number(cols) || 6);
  return (
    <Fragment>
      <tr>
        {Array.from({ length: count }).map((_, i) => (
          <td key={i} className={i === 0 ? "p-2" : undefined}>
            <Skeleton width={80} count={2} className="mx-auto" />
          </td>
        ))}
      </tr>
    </Fragment>
  );
}

export default EnquiriesTableSkelton;
